import { render } from "./StarContentAudio.vue?vue&type=template&id=34fcef6f&scoped=true&ts=true"
import script from "./StarContentAudio.vue?vue&type=script&lang=ts"
export * from "./StarContentAudio.vue?vue&type=script&lang=ts"

import "./StarContentAudio.vue?vue&type=style&index=0&id=34fcef6f&scoped=true&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34fcef6f"]])

export default __exports__